// extracted by mini-css-extract-plugin
export default {"root":"bottom-navigation-bar-mobile_root__ZnMbc"};